/* 「今の気分にぴったりのお酒は？」診断 v2（2026-10-08・Claude）
   文言：window.W99MQ_I18N（共通の文言）。タイプと問い：window.W99MQ_DATA（お酒版・ノンアル版・言語ごと。assets/w99-mood-quiz-data.js）。
   DATA が無い言語は、v1 の8タイプ（この中に内蔵）で動く。商品：#w99mq-products（区画が市場の文脈で出力）。
   何も書き込まない（カート・顧客・注文・cookie を触らない）。結果の共有は URL の ?r= だけ。 */
(function () {
  'use strict';
  var root = document.getElementById('w99mq');
  if (!root) return;
  var stage = root.querySelector('[data-w99mq-stage]');
  var I18N = window.W99MQ_I18N || {};
  var lang = root.dataset.lang || 'en';
  function pick(obj) { return obj && (obj[lang] || obj[(lang || '').split('-')[0]] || obj.en || obj.ja) || null; }
  var T = pick(I18N);
  if (!T) return;
  /* タイプ表は、その言語（か基底言語）の物だけ使う。無ければ null＝v1 の8タイプ（他言語の文で動かさない・査読 P2-10） */
  var DATAALL = window.W99MQ_DATA || {};
  var DATA = DATAALL[lang] || DATAALL[(lang || '').split('-')[0]] || null;
  var SHARED = DATAALL._shared || null; /* v3：選択肢の池（配点・札）は言語共通。文は DATA.labels */
  var country = (root.dataset.country || '').toUpperCase();
  var age = parseInt(root.dataset.age || '20', 10);
  var alcAllowed = root.dataset.alc === 'true';
  /* 日本以外では、お酒の道でも瓶や杯の無い絵を使う（AI-CAO 点検の守り。選択そのものは全地域で出す＝井上様 2026-10-08） */
  var picAlcOk = country === 'JP';
  var euuk = root.dataset.euuk === '1';
  var imgBase = root.dataset.img || '';
  var products = [];
  try { products = JSON.parse(document.getElementById('w99mq-products').textContent || '[]'); } catch (e) { products = []; }
  var byHandle = {}; products.forEach(function (p) { byHandle[p.h] = p; });

  /* v1 の8タイプ（DATA が無いときの保険） */
  var TYPES_V1 = {
    cozy:    { guide: 'kyuna',  pic: 'w99mq-result-futon.webp', picNa: 'w99mq-result-futon.webp', pk: ['liqueur','umeshu','cola'], s: 5, a: 2, r: 3, b: 3, fl: ['honey','cacao','fruit'], sv: ['milk','hot'], tm: ['night'] },
    citrus:  { guide: 'kyuna',  pic: 'w99mq-result-cola.webp', picNa: 'w99mq-result-cola.webp', pk: ['liqueur','gin','cola'], s: 3, a: 4, r: 3, b: 2, fl: ['citrus','herb'], sv: ['soda'], tm: ['afternoon'] },
    night:   { guide: 'shiuin', pic: 'w99mq-result-bartender.webp', picNa: 'w99mq-alt-karaoke-kyuna.webp', pk: ['whisky','grappa','rum','shochu'], s: 2, a: 2, r: 4, b: 5, fl: ['spice','cacao'], sv: ['ice','cocktail'], tm: ['midnight','night'] },
    bloom:   { guide: 'kyuna',  pic: 'w99mq-result-wine.webp', picNa: 'w99mq-alt-cola-shuiin-straw.webp', pk: ['liqueur','umeshu','sake'], s: 4, a: 3, r: 5, b: 2, fl: ['fruit','flower'], sv: ['soda','cocktail'], tm: ['night'] },
    spice:   { guide: 'shiuin', pic: 'w99mq-result-karaoke.webp', picNa: 'w99mq-result-karaoke.webp', pk: ['gin','rum','vermouth','cola'], s: 3, a: 2, r: 4, b: 3, fl: ['spice'], sv: ['soda','cocktail'], tm: ['night'] },
    classic: { guide: 'kyuna',  pic: 'w99mq-result-sipping.webp', picNa: 'w99mq-alt-riding-kyuna-front.webp', pk: ['sake','shochu'], s: 2, a: 3, r: 4, b: 3, fl: ['rice','herb'], sv: ['ice','hot'], tm: ['night'] },
    cheers:  { guide: 'duo',    pic: 'w99mq-result-riding.webp', picNa: 'w99mq-result-riding.webp', pk: ['gin','liqueur','umeshu'], s: 3, a: 3, r: 3, b: 2, fl: ['fruit','citrus'], sv: ['soda'], tm: ['afternoon'] },
    calm:    { guide: 'shiuin', pic: 'w99mq-result-cola-2.webp', picNa: 'w99mq-result-cola-2.webp', pk: ['sake','vermouth','tea'], s: 3, a: 2, r: 4, b: 2, fl: ['tea','herb'], sv: ['tea','hot'], tm: ['morning'] }
  };
  var QUESTIONS_V1 = [
    { id: 'q_mood',  w: [['cozy','calm'], ['citrus','cheers','spice'], ['night','classic'], ['spice','bloom']] },
    { id: 'q_treat', w: [['cozy','bloom'], ['citrus','classic'], ['spice','night'], ['calm','bloom','classic']] },
    { id: 'q_with',  w: [['calm','night'], ['bloom','night'], ['cheers','spice'], ['cozy','citrus']] },
    { id: 'q_time',  w: [['calm','citrus'], ['citrus','cheers','bloom'], ['night','classic','cozy'], ['cozy','night']] },
    { id: 'q_style', w: [['night','classic'], ['citrus','cheers','spice'], ['cozy','calm'], ['cozy','calm','bloom']] },
    { id: 'q_food',  w: [['cozy','bloom'], ['cheers','citrus','spice'], ['classic','night'], ['spice','citrus']] }
  ];
  var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE CH NO IS LI'.split(' ');
  var GULF = 'AE SA QA KW BH OM'.split(' ');
  function region() {
    if (lang === 'ar' || GULF.indexOf(country) >= 0) return 'gulf';
    if (country === 'JP') return 'jp';
    if (country === 'TW') return 'tw';
    if (country === 'HK' || country === 'MO') return 'hk';
    if (country === 'KR') return 'kr';
    if (country === 'GB') return 'uk';
    if (country === 'US') return 'us';
    if (country === 'AU' || country === 'NZ') return 'au';
    if (EU.indexOf(country) >= 0) return 'eu';
    return 'other';
  }
  function img(name) { return imgBase + name; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function list(v) { return String(v || '').toLowerCase().split(/[\s,，、|]+/).filter(Boolean); }
  function rand(n) { if (window.crypto && crypto.getRandomValues) { var a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] % n; } return Math.floor(Math.random() * n); }

  var state = { alc: false, i: 0, scores: {}, shown: [], tags: [] };
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = rand(i + 1), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  /* 問いの選択肢：v3 は池（pool／byRegion）から show 個を無作為に出す。v2 は固定の o＋w。v1 は T.q の文＋w */
  function optionsFor(q, i) {
    if (state.shown[i]) return state.shown[i];
    var out;
    if (q.use && SHARED) {
      /* v3：池から、この道で点が付き、この言語の文がある物だけ */
      var src, pre, m = mode(), labels = DATA.labels || {};
      if (q.use === 'food') { var reg = region(); src = SHARED.food[reg]; pre = reg + '/'; if (!src) { src = SHARED.pool.q_food; pre = 'q_food/'; } }
      else { src = SHARED.pool[q.id] || []; pre = q.id + '/'; }
      var pool = [];
      (src || []).forEach(function (o) {
        var w = o.w && o.w[m]; if (!w || !Object.keys(w).length) return;
        var lab = (m === 'na' && o.na ? labels['na:' + pre + o.id] : null) || labels[pre + o.id]; if (!lab) return;
        pool.push({ id: o.id, o: lab, w: w, tags: o.tags });
      });
      out = shuffle(pool).slice(0, q.show || 5);
    } else if (q.pool || q.byRegion) {
      var pool2 = q.byRegion ? (q.byRegion[region()] || q.byRegion.other || []) : q.pool;
      pool2 = pool2.filter(function (o) { return o.w && Object.keys(o.w).length; });
      out = shuffle(pool2).slice(0, q.show || 5);
    } else {
      var qt = qText(q), ws = qWeights(q);
      var opts = qt.o;
      if (q.id === 'q_food') { var FD = (DATA && DATA.food) || T.food || {}; var f = FD[region()] || FD.other; if (f) opts = f; }
      out = opts.map(function (label, k) { return { id: q.id + '_' + k, o: label, w: ws[k] || [] }; });
    }
    state.shown[i] = out; return out;
  }
  var hist = [];
  var pendingShared = null;
  var started = false;
  function render(html) {
    stage.innerHTML = html;
    if (!started) { started = true; return; }
    var h = stage.querySelector('h1,h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  /* いまの道（お酒／ノンアル）のタイプ表と問い */
  function mode() { return state.alc ? 'alc' : 'na'; }
  function types() {
    if (DATA && DATA[mode()] && DATA[mode()].types && DATA[mode()].types.length) {
      var o = {}; DATA[mode()].types.forEach(function (t) { o[t.id] = t; }); return o;
    }
    return TYPES_V1;
  }
  function questions() {
    if (DATA && DATA[mode()] && DATA[mode()].questions && DATA[mode()].questions.length) return DATA[mode()].questions;
    return QUESTIONS_V1;
  }
  /* 共有された結果（?r=）は、ノンアル・お酒のどちらの表からも探す */
  function findType(id) {
    if (DATA) {
      var m, i, ts;
      for (i = 0; i < 2; i++) { m = i ? 'alc' : 'na'; ts = (DATA[m] && DATA[m].types) || []; for (var k = 0; k < ts.length; k++) if (ts[k].id === id) return { t: ts[k], alc: m === 'alc' }; }
      return null;
    }
    return TYPES_V1[id] ? { t: TYPES_V1[id], alc: false } : null;
  }
  function qText(q) {
    if (q.q) return { q: q.q, o: q.o };
    var qt = T.q[q.id]; return { q: qt.q, o: qt.o };
  }
  function qWeights(q) { return (q.w && (Array.isArray(q.w) ? q.w : q.w[mode()])) || []; }
  /* 配点：v2 は {タイプ:点} の表、v1 はタイプ名の配列（1点ずつ） */
  function applyW(w, sign) {
    if (!w) return;
    if (Array.isArray(w)) { w.forEach(function (k) { if (k in state.scores) state.scores[k] += sign; }); return; }
    Object.keys(w).forEach(function (k) { if (k in state.scores) state.scores[k] += sign * (parseFloat(w[k]) || 0); });
  }
  function typeText(id) {
    var t = types()[id];
    if (t && t.name) return { name: t.name, desc: t.desc, how: t.how };
    var tt = T.types && T.types[id]; return tt || { name: id, desc: '', how: '' };
  }
  function guideImg(g) {
    if (!state.alc || !picAlcOk) return g === 'duo' ? 'w99mq-result-riding.webp' : (g === 'shiuin' ? 'w99mq-result-cola-2.webp' : 'w99mq-alt-cola-kyuna.webp');
    return g === 'duo' ? 'w99mq-duo-transparent.webp' : (g === 'shiuin' ? 'w99mq-shuiin-guide.webp' : 'w99mq-kyuna-guide.webp');
  }
  function guideName(g) { return g === 'duo' ? T.guide_duo : (g === 'shiuin' ? T.guide_shiuin : T.guide_kyuna); }
  function guide(g) {
    return '<figure class="w99mq-guide"><img src="' + img(guideImg(g)) + '" alt="' + esc(guideName(g)) + '" width="320" height="320" loading="lazy"><figcaption>' + esc(guideName(g)) + '</figcaption></figure>';
  }

  function cover() {
    render(
      '<section class="w99mq-cover">' +
        '<img class="w99mq-cover__img" src="' + img(picAlcOk ? 'w99mq-cover.webp' : 'w99mq-alt-riding-kyuna-front.webp') + '" alt="' + esc(T.cover_alt) + '" width="1600" height="900">' +
        '<div class="w99mq-cover__body">' +
          '<p class="w99mq-eyebrow">' + esc(T.eyebrow) + '</p>' +
          '<h1>' + esc(T.title) + '</h1>' +
          '<p class="w99mq-lead">' + esc(T.lead) + '</p>' +
          '<button type="button" class="w99mq-btn w99mq-btn--main" data-act="start">' + esc(T.start) + '</button>' +
          '<p class="w99mq-small">' + esc(T.privacy) + '</p>' +
        '</div>' +
      '</section>'
    );
  }
  function gate() {
    if (!alcAllowed) { state.alc = false; startQuestions(); return; }
    render(
      '<section class="w99mq-q">' + guide('kyuna') +
        '<h2>' + esc(T.gate_q) + '</h2>' +
        '<div class="w99mq-opts">' +
          '<button type="button" class="w99mq-opt" data-act="alc">' + esc(T.gate_alc) + '</button>' +
          '<button type="button" class="w99mq-opt" data-act="na">' + esc(T.gate_na) + '</button>' +
        '</div>' +
      '</section>'
    );
  }
  function ageCheck() {
    render(
      '<section class="w99mq-q">' + guide('shiuin') +
        '<h2>' + esc(fmt(T.age_q, { age: age })) + '</h2>' +
        '<div class="w99mq-opts w99mq-opts--2">' +
          '<button type="button" class="w99mq-opt" data-act="adult">' + esc(T.yes) + '</button>' +
          '<button type="button" class="w99mq-opt" data-act="minor">' + esc(T.no) + '</button>' +
        '</div>' +
        '<p class="w99mq-small">' + esc(fmt(T.age_note, { age: age })) + '</p>' +
      '</section>'
    );
  }
  function startQuestions() { state.i = 0; state.scores = {}; state.shown = []; state.tags = []; hist = []; Object.keys(types()).forEach(function (k) { state.scores[k] = 0; }); question(); }
  function question() {
    var qs = questions(), q = qs[state.i], qt = qText(q), opts = optionsFor(q, state.i);
    var html = '<section class="w99mq-q">' + guide(state.i % 2 ? 'shiuin' : 'kyuna') +
      '<p class="w99mq-step">' + esc(fmt(T.step, { n: state.i + 1, total: qs.length })) + '</p>' +
      '<div class="w99mq-bar" aria-hidden="true"><span style="width:' + Math.round((state.i) / qs.length * 100) + '%"></span></div>' +
      '<h2>' + esc(qt.q) + '</h2><div class="w99mq-opts">';
    opts.forEach(function (o, idx) { html += '<button type="button" class="w99mq-opt" data-act="ans" data-i="' + idx + '">' + esc(o.o) + '</button>'; });
    html += '</div>';
    if (state.i > 0) html += '<button type="button" class="w99mq-link" data-act="back">' + esc(T.back) + '</button>';
    html += '</section>';
    render(html);
  }
  function answer(idx) {
    var q = questions()[state.i], opt = optionsFor(q, state.i)[idx]; if (!opt) return;
    var w = opt.w || [];
    hist.push({ w: w, tags: opt.tags || null, qid: q.id });
    applyW(w, 1);
    state.tags = hist.map(function (x) { return x.tags; }).filter(Boolean);
    state.i += 1;
    if (state.i >= questions().length) result(pickType()); else question();
  }
  function back() {
    if (!hist.length) return;
    var last = hist.pop(); applyW(last.w, -1);
    state.tags = hist.map(function (x) { return x.tags; }).filter(Boolean);
    state.i -= 1;
    question();
  }
  function pickType() {
    var order = Object.keys(types());
    var best = order.reduce(function (b, k) { return state.scores[k] > state.scores[b] ? k : b; }, order[0]);
    var ties = order.filter(function (k) { return state.scores[k] === state.scores[best]; });
    function points(id, qid) { return hist.reduce(function (n, x) { return n + (x.qid === qid ? (Array.isArray(x.w) ? (x.w.indexOf(id) >= 0 ? 1 : 0) : Number(x.w[id] || 0)) : 0); }, 0); }
    ties.sort(function (a, b) { return points(b, 'q_taste') - points(a, 'q_taste') || points(b, 'q_mood') - points(a, 'q_mood') || order.indexOf(a) - order.indexOf(b); });
    return ties[0];
  }

  /* Confirmed numeric percentage only; a range or unknown value is not inferred. */
  function alcoholPercent(v) {
    if (v == null || v === '') return null;
    var x = String(v).normalize('NFKC').trim();
    if (!/^\d+(?:\.\d+)?\s*%?$/.test(x)) return null;
    var n = Number(x.replace('%', '').trim()); return n >= 0 && n <= 100 ? n : null;
  }
  /* Match the existing bilingual dish names, separately from beverage classes. */
  function foodTags(v) {
    var text = Array.isArray(v) ? v.join(' ') : String(v || '');
    var patterns = {
      bread: /パン|トースト|麵包|面包|bread|toast/i,
      egg: /卵|玉子|卵焼き|茶碗蒸し|荷包蛋|炒蛋|蒸蛋|egg/i,
      raw: /刺身|生魚|生鱼|生牡蠣|生蠔|生蚝|カルパッチョ|sashimi|carpaccio|tartare/i,
      creamy: /クリーム|奶油|ホワイトソース|アイス|冰淇淋|cream|white sauce/i,
      fat: /バター|奶油|ベーコン|培根|豚バラ|アボカド|酪梨|butter|bacon|avocado/i,
      fermented: /キムチ|泡菜|味噌|みそ|納豆|チーズ|起司|乳酪|ヨーグルト|優格|优格|kimchi|miso|yogurt|cheese/i,
      salty: /塩|鹽|盐|醤油|醬油|酱油|干し|乾物|salt|soy sauce/i,
      sweet: /黒蜜|砂糖|糖|蜂蜜|はちみつ|チョコ|巧克力|キャラメル|焦糖|ケーキ|蛋糕|プリン|布丁|sweet|honey|sugar|chocolate/i,
      umami: /出汁|だし|昆布|海苔|味噌|醤油|醬油|酱油|きのこ|茸|香菇|蘑菇|dashi|miso|mushroom/i,
      snack: /おつまみ|ナッツ|堅果|坚果|ポテトチップ|洋芋片|スナック|枝豆|小吃|snack|nuts|edamame/i,
      dessert: /チョコ|プリン|プディング|杏仁豆腐|ケーキ|アイス|スイーツ|甜點|甜点|巧克力|布丁|蛋糕|冰淇淋|dessert|chocolate|pudding|cake/i,
      fruit: /果物|フルーツ|いちご|苺|桃|マンゴー|水果|草莓|芒果|鳳梨|菠萝|バナナ|香蕉|banana|fruit|mango|berry/i,
      fried: /揚げ|唐揚|天ぷら|フライ|炸|鹹酥|盐酥|fried|tempura/i,
      meat: /肉|牛|豚|鶏|雞|鸡|羊|meat|beef|pork|chicken|lamb/i,
      fish: /魚|鱼|刺身|寿司|壽司|sushi|sashimi|fish/i,
      seafood: /魚|鱼|海鮮|海鲜|えび|蝦|虾|貝|牡蠣|生蠔|seafood|shrimp|oyster|fish/i,
      spicy: /辛|麻辣|辣|spicy|chili/i,
      soup: /鍋|汤|湯|スープ|soup|broth/i,
      rice: /飯|饭|米|おにぎり|rice/i,
      noodle: /麺|麵|面条|パスタ|うどん|そば|noodle|pasta/i,
      steamed: /蒸|小籠包|小笼包|steamed/i,
      simmered: /煮|滷|卤|燉|炖|simmer|stew/i,
      grilled: /焼|燒|烧|炭火|烤|grill|roast/i,
      cheese: /チーズ|起司|奶酪|乳酪|cheese/i,
      vegetable: /野菜|サラダ|蔬菜|沙拉|vegetable|salad/i
    };
    return Object.keys(patterns).filter(function (k) { return patterns[k].test(text); });
  }
  function scoreProduct(p, t) {
    var ax = t.axes || t;
    /* 型の味の軸との近さ（0〜16 を 8 点満点に） */
    var dist = Math.abs((ax.s || 3) - (p.s || 3)) + Math.abs((ax.a || 3) - (p.a || 3)) + Math.abs((ax.r || 3) - (p.r || 3)) + Math.abs((ax.b || 3) - (p.b || 3));
    var sc = Math.max(0, 8 - dist * 0.5);
    var fl = list(p.fl), sv = list(p.sv), tm = list(p.tm), pa = list(p.pa), food = foodTags(p.food);
    (t.fl || []).forEach(function (x) { if (fl.indexOf(x) >= 0) sc += 2; });
    if (t.pk && pa.some(function (x) { return t.pk.indexOf(x) >= 0; })) sc += 3;
    (t.sv || []).forEach(function (x) { if (sv.indexOf(x) >= 0) sc += 1; });
    (t.tm || []).forEach(function (x) { if (tm.indexOf(x) >= 0) sc += 1; });
    /* 型の設計で挙げた商品は少し優先（固定ではない） */
    if (t.products && t.products.indexOf(p.h) >= 0) sc += 2;
    /* 回答の選択肢に付いた札（風味・飲み方・時間帯・合う酒種・温度・質感）との一致 */
    state.tags.forEach(function (tg) {
      (tg.fl || []).forEach(function (x) { if (fl.indexOf(x) >= 0) sc += 1; });
      (tg.sv || []).forEach(function (x) { if (sv.indexOf(x) >= 0) sc += 1; });
      (tg.tm || []).forEach(function (x) { if (tm.indexOf(x) >= 0) sc += 0.5; });
      (tg.pa || []).forEach(function (x) { if (food.indexOf(x) >= 0) sc += 1.5; });
      if (tg.temp === 'hot' && sv.indexOf('hot') >= 0) sc += 1;
      if (tg.temp === 'cold' && (sv.indexOf('ice') >= 0 || sv.indexOf('soda') >= 0)) sc += 1;
      if (tg.tex === 'fizzy' && sv.indexOf('soda') >= 0) sc += 1;
      if (tg.tex === 'creamy' && sv.indexOf('milk') >= 0) sc += 1;
      /* 味の向き（甘い・酸っぱい・香り高い・コクがある／その逆） */
      (tg.ax || []).forEach(function (x) {
        var k = x.split('_')[0], hi = x.indexOf('_hi') > 0, v = { sweet: p.s, acid: p.a, aroma: p.r, body: p.b }[k];
        if (v == null) return; if (hi && v >= 4) sc += 1; if (!hi && v <= 2) sc += 1;
      });
      var abv = alcoholPercent(p.abv);
      if (tg.abv === 'low' && abv !== null && abv <= 10) sc += 0.5;
      if (tg.abv === 'mid' && abv !== null && abv > 10 && abv <= 20) sc += 0.5;
      if (tg.abv === 'high' && abv !== null && abv > 20) sc += 0.5;
    });
    return sc;
  }
  function sellable(p) { return p.av || (p.alc && country !== 'JP') || p.inq || euuk; }
  function stock(p) { return p.trk === false ? 999 : (p.q || 0); }
  /* 商品の選び方（井上様 2026-10-08）：その市場の全商品（お酒の道＝酒類＋ノンアル、ノンアルの道＝ノンアルだけ）を採点し、
     合う物（最高点から2点以内）の中で在庫の多い順に3本。同じ在庫なら無作為。買える（または問い合わせできる）物だけ */
  function picks(typeId, t) {
    t = t || types()[typeId];
    /* 飲料だけ（味の軸を持つ物。雑貨は軸が無い） */
    var pool = products.filter(function (p) { return (p.s || p.a || p.r || p.b) && (state.alc ? true : !p.alc) && sellable(p); });
    if (!pool.length) return [];
    var scored = pool.map(function (p) { return { p: p, sc: scoreProduct(p, t), q: stock(p), r: rand(1000) }; });
    var top = Math.max.apply(null, scored.map(function (x) { return x.sc; }));
    var band = scored.filter(function (x) { return x.sc >= top - 2; });
    
    band.sort(function (x, y) { return (y.q - x.q) || (y.sc - x.sc) || (x.r - y.r); });
    var out = band.slice(0, 3).map(function (x) { return x.p; });
    if (out.length < 3) scored.filter(function (x) { return x.sc < top - 2; }).sort(function (x, y) { return y.sc - x.sc || y.q - x.q; }).forEach(function (x) { if (out.length < 3) out.push(x.p); });
    /* 買える物が3本に足りなければ、売り切れの飲料を合う順で後ろに足す（売り切れ表示付き） */
    if (out.length < 3) {
      products.filter(function (p) { return (p.s || p.a || p.r || p.b) && (state.alc ? true : !p.alc) && !sellable(p); })
        .map(function (p) { return { p: p, sc: scoreProduct(p, t) }; }).sort(function (x, y) { return y.sc - x.sc; })
        .forEach(function (x) { if (out.length < 3) out.push(x.p); });
    }
    return out;
  }
  function alcNotice() {
    var r = region();
    if (r === 'jp') return T.notice_jp;
    if (r === 'tw') return T.notice_tw;
    if (r === 'eu' && country === 'FR') return T.notice_fr;
    return T.notice_default;
  }
  /* 酒の格言（window.W99_QUOTES）。原語と読み手の言語の訳を並べる */
  function quoteBlock() {
    var Q = window.W99_QUOTES; if (!Q || !Q.quotes || !Q.quotes.length) return '';
    var baseLang = (lang || '').split('-')[0];
    var qs = Q.quotes.filter(function (q) { return !(q.hide && (q.hide.indexOf(lang) >= 0 || q.hide.indexOf(baseLang) >= 0)); });
    if (!qs.length) return '';
    var q = qs[rand(qs.length)];
    var tr = (q.tr && (q.tr[lang] || q.tr[(lang || '').split('-')[0]] || q.tr.en)) || '';
    var who = (q.who && (q.who[lang] || q.who.en)) || '';
    var head = (Q.head && (Q.head[lang] || Q.head.en)) || '';
    return '<section class="w99-quote"><p class="w99-quote__head">' + esc(head) + '</p>' +
      '<p class="w99-quote__orig" lang="' + esc(q.lang) + '"' + (q.lang === 'ar' || q.lang === 'he' || q.lang === 'fa' ? ' dir="rtl"' : '') + '>' + esc(q.orig) + '</p>' +
      (tr && tr !== q.orig ? '<p class="w99-quote__tr">' + esc(tr) + '</p>' : '') +
      (who ? '<p class="w99-quote__who">— ' + esc(who) + '</p>' : '') + '</section>';
  }
  function result(typeId, shared) {
    var ft = findType(typeId); if (!ft) { cover(); return; }
    var t = ft.t;
    var tt = (t.name) ? { name: t.name, desc: t.desc, how: t.how } : typeText(typeId);
    /* 共有されたお酒のタイプは年齢確認後に本文を出す。個別回答のない共有では商品を出さずノンアルの絵を使う */
    var items = (shared && ft.alc) ? [] : picks(typeId, t);
    var hasAlc = items.some(function (p) { return p.alc; });
    var substitute = !shared && items.length && t.products && t.products.length && !items.some(function (p) { return t.products.indexOf(p.h) >= 0; });
    if (substitute) tt = { name: tt.name, desc: tt.desc, how: '' };
    var pic = (state.alc && !shared && picAlcOk) ? (t.pic || t.picNa) : (t.picNa || t.pic);
    var url = location.origin + location.pathname + '?view=mood-quiz&r=' + typeId;
    var html = '<section class="w99mq-result">' +
      '<p class="w99mq-eyebrow">' + esc(T.result_head) + '</p>' +
      '<div class="w99mq-result__hero"><img src="' + img(pic) + '" alt="' + esc(tt.name) + '" width="800" height="800">' +
      '<div><h2>' + esc(tt.name) + '</h2><p>' + esc(tt.desc) + '</p>' + (tt.how ? '<p class="w99mq-how"><strong>' + esc(T.how_label) + '</strong> ' + esc(tt.how) + '</p>' : '') + '</div></div>' +
      ((shared && ft.alc) ? '' : '<h3>' + esc(state.alc ? T.reco_alc : T.reco_na) + '</h3>') +
      (substitute ? '<p class="w99mq-small">' + esc(T.selection_note) + '</p>' : '');
    if (!items.length) {
      html += (shared && ft.alc) ? '' : '<p>' + esc(T.none) + '</p>';
    } else {
      html += '<ul class="w99mq-items">';
      items.forEach(function (p) {
        var inquiry = (p.alc && country !== 'JP') || p.inq || euuk;
        html += '<li class="w99mq-item"><a href="' + esc(p.u) + '">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" width="240" height="240" loading="lazy">' : '') +
          '<span class="w99mq-item__t">' + esc(p.t) + '</span>' +
          '<span class="w99mq-item__p">' + (inquiry ? esc(T.inquiry_only) : esc(p.pr)) + '</span>' +
          (p.av || inquiry ? '' : '<span class="w99mq-item__s">' + esc(T.sold_out) + '</span>') +
          '</a></li>';
      });
      html += '</ul>';
    }
    if (hasAlc || state.alc) html += '<p class="w99mq-notice">' + esc(alcNotice()) + '</p>';
    html += '<div class="w99mq-actions">' +
      '<button type="button" class="w99mq-btn" data-act="retry">' + esc(T.retry) + '</button>' +
      '<button type="button" class="w99mq-btn w99mq-btn--ghost" data-act="share" data-url="' + esc(url) + '">' + esc(T.share) + '</button>' +
      '</div><p class="w99mq-small">' + esc(T.disclaimer) + '</p>' + quoteBlock() + '</section>';
    render(html);
  }

  stage.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var a = b.dataset.act;
    if (a === 'start') gate();
    else if (a === 'alc') ageCheck();
    else if (a === 'na' || a === 'minor') { state.alc = false; if (pendingShared) { pendingShared = null; cover(); } else startQuestions(); }
    else if (a === 'adult') { state.alc = true; if (pendingShared) { var ps = pendingShared; pendingShared = null; result(ps, true); } else startQuestions(); }
    else if (a === 'ans') answer(parseInt(b.dataset.i, 10));
    else if (a === 'back') back();
    else if (a === 'retry') { hist = []; cover(); }
    else if (a === 'share') {
      var u = b.dataset.url;
      if (navigator.share) { navigator.share({ title: T.title, url: u }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(u).then(function () { b.textContent = T.copied; }); }
    }
  });

  /* 共有結果（?r=）の酒タイプは、本文を表示する前に年齢確認を通す */
  var shared = new URLSearchParams(location.search).get('r');
  state.alc = false;
  var sharedType = shared && findType(shared);
  if (sharedType && sharedType.alc && alcAllowed) { pendingShared = shared; ageCheck(); }
  else if (sharedType && !sharedType.alc) result(shared, true);
  else cover();
})();
